<template>
  <div class="volunteer-planning">
    <!-- 页面标题 -->
    <div class="page-header">
      <h1 class="title">报考军校志愿规划建议</h1>
    </div>

    <!-- 调查问卷部分 -->
    <div v-if="!showResult" class="survey-section">
      <div class="survey-card">
        <h2 class="survey-title">请填写以下信息</h2>
        
        <!-- 用户电子档案信息 -->
        <div class="user-info-card">
          <div class="info-header">
            <span class="card-title">电子档案信息</span>
            <div class="action-buttons">
              <el-button v-if="!isEditing" type="primary" @click="startEdit" class="edit-btn" size="small">
                <i class="fa fa-edit"></i> 编辑
              </el-button>
              <template v-else>
                <el-button type="success" @click="saveEdit" class="save-btn" size="small">
                  <i class="fa fa-save"></i> 保存
                </el-button>
                <el-button type="default" @click="cancelEdit" class="cancel-btn" size="small">
                  <i class="fa fa-times"></i> 取消
                </el-button>
              </template>
            </div>
          </div>
          <div class="info-grid">
            <div class="info-box">
              <span class="info-label">性 别：</span>
              <template v-if="!isEditing">
                <span class="info-value">{{ userProfile.gender || '未获取' }}</span>
              </template>
              <template v-else>
                <select v-model="editProfile.gender" class="info-select">
                  <option value="">请选择性别</option>
                  <option v-for="g in genderOptions" :key="g" :value="g">{{ g }}</option>
                </select>
              </template>
            </div>
            <div class="info-box">
              <span class="info-label">省 份：</span>
              <template v-if="!isEditing">
                <span class="info-value">{{ userProfile.province || '未获取' }}</span>
              </template>
              <template v-else>
                <select v-model="editProfile.province" class="info-select">
                  <option value="">请选择省份</option>
                  <option v-for="p in provinceOptions" :key="p" :value="p">{{ p }}</option>
                </select>
              </template>
            </div>

            <div class="info-box">
              <span class="info-label">选科组合：</span>
              <template v-if="!isEditing">
                <span class="info-value">{{ userProfile.subjects || '未获取' }}</span>
              </template>
              <template v-else>
                <select v-model="editProfile.subjects" class="info-select">
                  <option value="">请选择选科组合</option>
                  <option value="物理类">物理类</option>
                  <option value="历史类">历史类</option>
                </select>
              </template>
            </div>
            <div class="info-box">
              <span class="info-label">考核分数：</span>
              <template v-if="!isEditing">
                <span class="info-value highlight">{{ userProfile.score || '未获取' }}</span>
              </template>
              <template v-else>
                <input type="number" v-model="editProfile.score" class="info-input highlight" placeholder="请输入分数" />
              </template>
            </div>
            <div class="info-box">
              <span class="info-label">省内位次（{{ rankYear || '某某年' }}）：</span>
              <template v-if="!isEditing">
                <span class="info-value highlight">{{ userProfile.rank || '未获取' }}</span>
              </template>
              <template v-else>
                <input type="number" v-model="editProfile.rank" class="info-input highlight" placeholder="根据分数自动获取" disabled />
              </template>
            </div>
            <div class="info-box">
              <span class="info-label">意向院校：</span>
              <template v-if="!isEditing">
                <span class="info-value">{{ userProfile.schoolName || '未获取' }}</span>
              </template>
              <template v-else>
                <el-select
                  v-model="editProfile.schoolName"
                  placeholder="请选择意向院校"
                  filterable
                  style="width: 100%"
                  @change="handleSchoolChange"
                >
                  <el-option
                    v-for="school in schools"
                    :key="school.value"
                    :label="school.label"
                    :value="school.label"
                  />
                </el-select>
              </template>
            </div>
            <div class="info-box">
              <span class="info-label">身 高(cm)：</span>
              <template v-if="!isEditing">
                <span class="info-value">{{ userProfile.height || '未获取' }}</span>
              </template>
              <template v-else>
                <input type="number" step="0.1" v-model="editProfile.height" class="info-input" placeholder="请输入身高" />
              </template>
            </div>
            <div class="info-box">
              <span class="info-label">体 重(kg)：</span>
              <template v-if="!isEditing">
                <span class="info-value">{{ userProfile.weight || '未获取' }}</span>
              </template>
              <template v-else>
                <input type="number" step="0.1" v-model="editProfile.weight" class="info-input" placeholder="请输入体重" />
              </template>
            </div>
            <div class="info-box">
              <span class="info-label">视 力：</span>
              <template v-if="!isEditing">
                <span class="info-value">{{ userProfile.vision || '未获取' }}</span>
              </template>
              <template v-else>
                <input type="text" v-model="editProfile.vision" class="info-input" placeholder="请输入视力" />
              </template>
            </div>
            <div class="info-box">
              <span class="info-label">体检结论：</span>
              <template v-if="!isEditing">
                <span class="info-value" :class="{ 'medical-pass': userProfile.medicalResult === '合格', 'medical-fail': userProfile.medicalResult === '不合格' }">
                  {{ userProfile.medicalResult || '未获取' }}
                </span>
              </template>
              <template v-else>
                <select v-model="editProfile.medicalResult" class="info-select">
                  <option value="">请选择体检结论</option>
                  <option v-for="m in medicalResultOptions" :key="m" :value="m">{{ m }}</option>
                </select>
              </template>
            </div>
            <div class="info-box">
              <span class="info-label">政审结论：</span>
              <template v-if="!isEditing">
                <span class="info-value" :class="{ 'political-pass': userProfile.politicalReview === '合格', 'political-fail': userProfile.politicalReview === '不合格' }">
                  {{ userProfile.politicalReview || '未获取' }}
                </span>
              </template>
              <template v-else>
                <select v-model="editProfile.politicalReview" class="info-select">
                  <option value="">请选择政审结论</option>
                  <option v-for="p in politicalReviewOptions" :key="p" :value="p">{{ p }}</option>
                </select>
              </template>
            </div>
          </div>
        </div>
        
        <!-- 等待动画效果 -->
        <div v-if="loading" class="waiting-container">
          <div class="waiting-animation">
            <span class="waiting-text">{{ loadingText }}</span>
            <span class="waiting-dots">
              <span class="dot">.</span>
              <span class="dot">.</span>
              <span class="dot">.</span>
            </span>
          </div>
        </div>
        
        <!-- 问题列表 -->
        <div v-else class="questions-list" :class="{ disabled: userProfile.politicalReview === '不合格' }">
          <!-- 政审不合格提示 -->
          <div v-if="userProfile.politicalReview === '不合格'" class="disabled-overlay">
            <div class="disabled-content">
              <i class="fa fa-warning warning-icon"></i>
              <p class="disabled-title">政审结论不合格</p>
              <p class="disabled-desc">您的政审结论为不合格，暂无法进行志愿规划测试</p>
            </div>
          </div>
          
          <div v-for="(question, index) in questions" :key="question.id" class="question-item">
            <div class="question-header">
              <span class="question-number">{{ index + 1 }}.</span>
              <span class="question-text">{{ question.title }}</span>
            </div>
            <div class="options-list">
              <label 
                v-for="(option, optIndex) in question.options" 
                :key="option.optionId" 
                class="option-item"
                :class="{ selected: form.answers[question.id] === option.optionId, disabled: userProfile.politicalReview === '不合格' }"
              >
                <input 
                  type="radio" 
                  :name="'question-' + question.id" 
                  :value="option.optionId" 
                  v-model="form.answers[question.id]"
                  :disabled="userProfile.politicalReview === '不合格'"
                />
                <span class="option-label">{{ String.fromCharCode(65 + optIndex) }}</span>
                <span class="option-text">{{ option.label }}</span>
                <i v-if="form.answers[question.id] === option.optionId" class="fa fa-check-circle selected-icon"></i>
              </label>
            </div>
          </div>
        </div>

        <!-- 提交按钮 -->
        <div class="submit-section">
          <el-button type="primary" @click="submitSurvey" class="submit-btn" :disabled="loading">
            <i class="fa fa-paper-plane"></i> 立即测试
          </el-button>
        </div>
      </div>
    </div>

    <!-- 结果展示部分 -->
    <div v-else class="result-section">
      <div v-if="loading" class="loading-container">
        <el-spin size="large" :tip="loadingText"></el-spin>
      </div>
      <div v-else class="result-card">
        <div class="result-header">
          <!-- <h2 class="result-title">报考军校志愿规划建议</h2> -->
        </div>

        <!-- 用户信息卡片 -->
        <div class="user-info-card">
          <div class="info-grid">
            <div class="info-box">
              <span class="info-label">性 别：</span>
              <span class="info-value">{{ resultData?.userInfo?.gender || userProfile.gender || '男' }}</span>
            </div>
            <div class="info-box">
              <span class="info-label">省 份：</span>
              <span class="info-value">{{ userProfile.province || '未获取' }}</span>
            </div>
            <div class="info-box">
              <span class="info-label">选科组合：</span>
              <span class="info-value">{{ resultData?.userInfo?.subjectType || userProfile.subjects || '历史+政治+生物' }}</span>
            </div>
            <div class="info-box">
              <span class="info-label">考核分数：</span>
              <span class="info-value highlight">{{ resultData?.userInfo?.examScore || userProfile.score || '474.2' }}</span>
            </div>
            <div class="info-box">
              <span class="info-label">省内位次：</span>
              <span class="info-value highlight">{{ resultData?.userInfo?.examRank || userProfile.rank || '24251' }}</span>
            </div>
            <div class="info-box">
              <span class="info-label">意向院校：</span>
              <span class="info-value">{{ userProfile.schoolName || '未获取' }}</span>
            </div>
            <div class="info-box">
              <span class="info-label">身 高(cm)：</span>
              <span class="info-value">{{ userProfile.height || '未获取' }}</span>
            </div>
            <div class="info-box">
              <span class="info-label">体 重(kg)：</span>
              <span class="info-value">{{ userProfile.weight || '未获取' }}</span>
            </div>
            <div class="info-box">
              <span class="info-label">视 力：</span>
              <span class="info-value">{{ userProfile.vision || '未获取' }}</span>
            </div>
            <div class="info-box">
              <span class="info-label">体检结论：</span>
              <span class="info-value" :class="{ 'medical-pass': userProfile.medicalResult === '合格', 'medical-fail': userProfile.medicalResult === '不合格' }">
                {{ userProfile.medicalResult || '未获取' }}
              </span>
            </div>
            <div class="info-box">
              <span class="info-label">政审结论：</span>
              <span class="info-value" :class="{ 'political-pass': userProfile.politicalReview === '合格', 'political-fail': userProfile.politicalReview === '不合格' }">
                {{ userProfile.politicalReview || '未获取' }}
              </span>
            </div>
          </div>
        </div>

        <!-- 规划建议内容 -->
        <div v-if="resultData?.planningAdvice" class="advice-section" v-html="resultData.planningAdvice"></div>
        
        <!-- 备用内容（当接口返回为空时） -->
        <div v-else>
          <!-- 分析建议引言 -->
          <div class="intro-section">
            <p class="intro-text">
              根据2025年军队院校招生政策及录取规则，结合你的高考成绩（选科组合：{{ resultData?.userInfo?.subjectType || userProfile.subjects || '历史+政治+生物' }}，{{ resultData?.userInfo?.gender || userProfile.gender || '男' }}{{ resultData?.userInfo?.examScore || userProfile.score || '474.2' }}分，位次：{{ resultData?.userInfo?.examRank || userProfile.rank || '24251' }}），以下分析及建议供参考：
            </p>
          </div>

          <!-- 关键政策与竞争形势 -->
          <div class="section-card">
            <h3 class="section-title">一、关键政策与竞争形势</h3>
            
            <!-- 报考资格与排名定位 -->
            <div class="subsection">
              <h4 class="subsection-title">（一）报考资格与排名定位</h4>
              <div class="content-block">
                <h5 class="content-title">1. 报名资格</h5>
                <p class="content-text">
                  你参加了2025年的统一高考、通过政治审查，具备报考资格。
                </p>
              </div>
              <div class="content-block">
                <h5 class="content-title">2. 排名位次</h5>
                <p class="content-text">
                  参考2024年一分一档表（历史类），{{ resultData?.userInfo?.examScore || userProfile.score || '474.2' }}分（排名{{ resultData?.userInfo?.examRank || userProfile.rank || '24251' }}）。
                </p>
              </div>
            </div>

            <!-- 招生计划 -->
            <div class="subsection">
              <h4 class="subsection-title">（二）招生计划</h4>
              <div class="content-block">
                <p class="content-text">
                  <strong>2025年军校招生招生计划人数：</strong>1134人，男生；物理类：1050人，历史类12人，合计1062人；女生：物理类70人，历史类12人；合计72人。
                </p>
              </div>
            </div>

            <!-- 历年分数与竞争趋势 -->
            <div class="subsection">
              <h4 class="subsection-title">（三）历年分数与竞争趋势</h4>
              <div class="content-block">
                <p class="content-text">
                  从提供的数据来看，2023-2025年，相同分数对应的位次逐年下降。这反映出近年来高考竞争愈发激烈，高分段考生人数增多，想考入理想军校的难度加大。
                </p>
              </div>
            </div>
          </div>

          <!-- 推荐院校及专业 -->
          <div class="section-card">
            <h3 class="section-title">二、推荐院校及专业</h3>
            <div class="content-block">
              <p class="content-text">
                根据您的分数，暂时未找到匹配的院校推荐。建议关注各军校招生政策变化，合理选择报考院校。
              </p>
            </div>
            <div class="content-block">
              <p class="content-text">
                  综合{{ resultData?.userInfo?.userName || userProfile.name || '默雅56' }}同学的高考成绩{{ resultData?.userInfo?.examScore || userProfile.score || '474.2' }}分、位次{{ resultData?.userInfo?.examRank || userProfile.rank || '24251' }}，结合各军校历年分数线、位次以及招生政策等因素，通过合理选择推荐院校及专业，并遵循科学的报考策略，在报考军校时能够提高被录取的概率。
                </p>
            </div>
          </div>
        </div>

        <!-- 重新测试按钮 -->
        <div class="retest-section">
          <el-button type="primary" @click="resetSurvey" class="retest-btn">
            <i class="fa fa-refresh"></i> 重新测试
          </el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, reactive, onMounted, watch } from 'vue';
import { ElMessage } from 'element-plus';
import { getSurveyQuestions, saveSurveyAnswers, getSurveyResult } from '@/api/surveyApi';
import { getStudentProfile, saveStudentProfile } from '@/api/studentProfileApi';
import { getRankByScore } from '@/api/processApi';
import { getAllSchoolsWithMajors } from '@/api/schoolApi';

const showResult = ref(false);
const loading = ref(false);
const loadingText = ref('加载中...');
const questions = ref([]);
const schools = ref([]);
const resultData = ref(null);
const isEditing = ref(false);
const rankYear = ref('');

const form = reactive({
  answers: {}
});

const userProfile = reactive({
  gender: '',
  subjects: '',
  score: '',
  rank: '',
  province: '',
  schoolName: '',
  height: '',
  weight: '',
  vision: '',
  medicalResult: '',
  politicalReview: ''
});

const editProfile = reactive({
  gender: '',
  subjects: '',
  score: '',
  rank: '',
  province: '',
  schoolName: '',
  height: '',
  weight: '',
  vision: '',
  medicalResult: '',
  politicalReview: ''
});

// 根据分数和选科组合自动获取位次和年份
const fetchRankByScore = async (score, subjectType) => {
  console.log('fetchRankByScore called:', { score, subjectType });
  
  if (!score || score < 0) {
    rankYear.value = '';
    editProfile.rank = '';
    return;
  }
  
  // 根据选科组合确定type参数：物理类为0，历史类为1，默认0
  const type = subjectType === '历史类' ? '1' : '0';
  console.log('Calling API with type:', type);
  
  try {
    const response = await getRankByScore(score, type);
    console.log('API response:', response);
    
    if (response.data.code === 200 && response.data.data) {
      const data = response.data.data;
      rankYear.value = data.years || '';
      editProfile.rank = data.rank !== undefined && data.rank !== null ? String(data.rank) : '';
      console.log('Updated rank:', editProfile.rank);
    } else {
      console.log('API returned no data');
      editProfile.rank = '';
    }
  } catch (error) {
    console.error('获取位次失败:', error);
  }
};

// 监听分数变化，自动获取位次
watch(() => editProfile.score, (newScore) => {
  if (isEditing.value && newScore) {
    fetchRankByScore(newScore, editProfile.subjects);
  }
});

// 监听选科组合变化，自动重新获取位次
watch(() => editProfile.subjects, (newSubjects) => {
  console.log('Subjects changed:', newSubjects);
  console.log('isEditing:', isEditing.value, 'score:', editProfile.score);
  
  if (isEditing.value && editProfile.score) {
    console.log('Fetching rank with new subject type');
    fetchRankByScore(editProfile.score, newSubjects);
  }
});

const genderOptions = ['男', '女'];
const provinceOptions = [
  '北京', '天津', '河北', '山西', '内蒙古', '辽宁', '吉林', '黑龙江',
  '上海', '江苏', '浙江', '安徽', '福建', '江西', '山东', '河南',
  '湖北', '湖南', '广东', '广西', '海南', '重庆', '四川', '贵州',
  '云南', '西藏', '陕西', '甘肃', '青海', '宁夏', '新疆'
];
const medicalResultOptions = ['合格', '不合格'];
const politicalReviewOptions = ['合格', '不合格'];

// 获取问卷题目列表
const fetchQuestions = async () => {
  loading.value = true;
  try {
    const response = await getSurveyQuestions();
    if (response.data.code === 200) {
      questions.value = response.data.data;
      // 初始化答案对象
      questions.value.forEach(q => {
        form.answers[q.id] = '';
      });
    }
  } catch (error) {
    console.error('获取问卷题目失败:', error);
  } finally {
    loading.value = false;
  }
};

// 获取院校列表
const loadSchools = async () => {
  try {
    const response = await getAllSchoolsWithMajors();
    if (response.data.code === 200) {
      const schoolList = response.data.data.list;
      schools.value = schoolList.map((school) => ({
        value: school.id,
        label: school.name,
      }));
    }
  } catch (error) {
    console.error('获取院校列表失败:', error);
  }
};

// 院校选择变化处理
const handleSchoolChange = (schoolId) => {
  const school = schools.value.find((s) => s.value === schoolId);
  if (school) {
    editProfile.schoolName = school.label;
    userProfile.schoolName = school.label;
  }
};

// 获取用户电子档案
const fetchUserProfile = async () => {
  try {
    console.log('开始调用getStudentProfile接口...');
    const response = await getStudentProfile();
    console.log('getStudentProfile接口响应:', response);
    if (response.data.code === 200) {
      const profile = response.data.data;
      console.log('用户档案数据:', profile);
      userProfile.gender = profile.gender === 1 ? '男' : '女';
      userProfile.subjects = profile.subjectType || '';
      userProfile.score = profile.examScore || '';
      userProfile.rank = profile.examRank || '';
      userProfile.province = profile.province || '';
      userProfile.schoolName = profile.schoolName || '';
      userProfile.height = profile.height || '';
      userProfile.weight = profile.weight || '';
      userProfile.vision = profile.vision || '';
      userProfile.medicalResult = profile.medicalResult || '';
      userProfile.politicalReview = profile.politicalReview || '';
      copyProfileToEdit();
      console.log('userProfile更新后:', userProfile);
      
      // 根据分数获取位次年份
      if (userProfile.score) {
        const rankResponse = await getRankByScore(userProfile.score);
        if (rankResponse.data.code === 200 && rankResponse.data.data) {
          rankYear.value = rankResponse.data.data.years || '';
        }
      }
    } else {
      console.log('接口返回非200状态:', response.data.code, response.data.msg);
    }
  } catch (error) {
    console.error('获取用户电子档案失败:', error);
    console.error('错误详情:', error.response?.data || error.message);
  }
};

// 提交问卷
const submitSurvey = async () => {
  // 检查政审结论是否为不合格
  if (userProfile.politicalReview === '不合格') {
    ElMessage.warning('您的政审结论为不合格，暂无法进行志愿规划测试');
    return;
  }
  
  // 检查电子档案信息是否填写完整
  const requiredFields = [
    { field: 'gender', label: '性别' },
    { field: 'province', label: '省份' },
    { field: 'subjects', label: '选科组合' },
    { field: 'score', label: '考核分数' },
    { field: 'rank', label: '省内位次' },
    { field: 'schoolName', label: '意向院校' },
    { field: 'height', label: '身高' },
    { field: 'weight', label: '体重' },
    { field: 'vision', label: '视力' },
    { field: 'medicalResult', label: '体检结论' },
    { field: 'politicalReview', label: '政审结论' }
  ];
  
  const missingFields = requiredFields.filter(field => !userProfile[field.field]);
  
  if (missingFields.length > 0) {
    ElMessage({
      message: '请填写个人电子档案信息',
      type: 'warning',
      duration: 2000
    });
    
    // 滚动到电子档案区域
    const userInfoCard = document.querySelector('.user-info-card');
    if (userInfoCard) {
      userInfoCard.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
    return;
  }
  
  // 检查是否所有问题都已回答
  const unanswered = questions.value.filter(q => !form.answers[q.id]);
  if (unanswered.length > 0) {
    ElMessage({
      message: '请回答所有问题！',
      type: 'warning',
      duration: 2000
    });
    
    // 定位到第一个未回答的问题
    const firstUnansweredIndex = questions.value.findIndex(q => !form.answers[q.id]);
    const questionItems = document.querySelectorAll('.question-item');
    if (questionItems[firstUnansweredIndex]) {
      questionItems[firstUnansweredIndex].scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
    return;
  }
  
  // 构建答案数组
  const answers = questions.value.map(q => ({
    questionId: q.id,
    optionId: form.answers[q.id]
  }));
  
  loading.value = true;
  loadingText.value = '正在处理您的请求...';
  
  try {
    // 构建用户档案信息
    const userInfo = {
      gender: userProfile.gender,
      subjectType: userProfile.subjects,
      examScore: userProfile.score,
      examRank: userProfile.rank,
      province: userProfile.province,
      schoolName: userProfile.schoolName,
      height: userProfile.height,
      weight: userProfile.weight,
      vision: userProfile.vision,
      medicalResult: userProfile.medicalResult,
      politicalReview: userProfile.politicalReview
    };
    
    console.log('发送给后端的完整用户信息:', userInfo);
    console.log('发送给后端的问卷答案:', answers);
    
    // 第一步：保存问卷答案
    loadingText.value = '正在保存您的问卷答案...';
    const saveResponse = await saveSurveyAnswers({ answers });
    if (saveResponse.data.code !== 200) {
      ElMessage.error('保存问卷答案失败');
      return;
    }
    
    // 第二步：提交用户信息获取规划建议
    loadingText.value = '正在生成志愿规划建议...';
    const resultResponse = await getSurveyResult({ userInfo, answers });
    if (resultResponse.data.code === 200) {
      // 直接使用返回的结果，无需再次请求
      resultData.value = resultResponse.data.data;
      showResult.value = true;
      loadingText.value = '正在生成志愿规划建议...';
      // 页面滚动到顶部
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  } catch (error) {
    console.error('提交问卷失败:', error);
    ElMessage.error('提交失败，请稍后重试');
  } finally {
    loading.value = false;
    loadingText.value = '加载中...';
  }
};

// 获取志愿规划建议结果
const fetchResult = async () => {
  loading.value = true;
  try {
    const response = await getSurveyResult();
    if (response.data.code === 200) {
      resultData.value = response.data.data;
      showResult.value = true;
      // 页面滚动到顶部
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  } catch (error) {
    console.error('获取规划建议失败:', error);
  } finally {
    loading.value = false;
  }
};

// 复制用户档案到编辑对象
const copyProfileToEdit = () => {
  editProfile.gender = userProfile.gender;
  editProfile.subjects = userProfile.subjects;
  editProfile.score = userProfile.score;
  editProfile.rank = userProfile.rank;
  editProfile.province = userProfile.province;
  editProfile.schoolName = userProfile.schoolId;
  editProfile.height = userProfile.height;
  editProfile.weight = userProfile.weight;
  editProfile.vision = userProfile.vision;
  editProfile.medicalResult = userProfile.medicalResult;
  editProfile.politicalReview = userProfile.politicalReview;
};

// 开始编辑
const startEdit = () => {
  copyProfileToEdit();
  if (userProfile.score) {
    fetchRankByScore(userProfile.score, userProfile.subjects);
  }
  isEditing.value = true;
};

// 取消编辑
const cancelEdit = () => {
  isEditing.value = false;
};

// 保存编辑
const saveEdit = async () => {
  // 验证所有必填字段
  const requiredFields = [
    { field: editProfile.gender, label: '性别' },
    { field: editProfile.province, label: '省份' },
    { field: editProfile.subjects, label: '选科组合' },
    { field: editProfile.score, label: '考核分数' },
    { field: editProfile.rank, label: '省内位次' },
    { field: editProfile.schoolName, label: '意向院校' },
    { field: editProfile.height, label: '身高' },
    { field: editProfile.weight, label: '体重' },
    { field: editProfile.vision, label: '视力' },
    { field: editProfile.medicalResult, label: '体检结论' },
    { field: editProfile.politicalReview, label: '政审结论' }
  ];
  
  // 检查是否有未填写的字段
  const missingField = requiredFields.find(item => !item.field);
  if (missingField) {
    ElMessage.warning(`请填写${missingField.label}`);
    return;
  }

  loading.value = true;
  try {
    const data = {
      province: editProfile.province,
      gender: editProfile.gender === '男' ? 1 : 2,
      subjectType: editProfile.subjects,
      examScore: parseFloat(editProfile.score),
      examRank: parseInt(editProfile.rank),
      schoolName: editProfile.schoolName || undefined,
      height: editProfile.height ? parseFloat(editProfile.height) : undefined,
      weight: editProfile.weight ? parseFloat(editProfile.weight) : undefined,
      vision: editProfile.vision || undefined,
      medicalResult: editProfile.medicalResult || undefined,
      politicalReview: editProfile.politicalReview || undefined
    };

    const response = await saveStudentProfile(data);
    if (response.data.code === 200) {
      // 更新userProfile
      userProfile.gender = editProfile.gender;
      userProfile.subjects = editProfile.subjects;
      userProfile.score = editProfile.score;
      userProfile.rank = editProfile.rank;
      userProfile.province = editProfile.province;
      userProfile.schoolName = editProfile.schoolName;
      userProfile.height = editProfile.height;
      userProfile.weight = editProfile.weight;
      userProfile.vision = editProfile.vision;
      userProfile.medicalResult = editProfile.medicalResult;
      userProfile.politicalReview = editProfile.politicalReview;
      isEditing.value = false;
      ElMessage.success('保存成功');
    } else {
      ElMessage.error('保存失败：' + response.data.msg);
    }
  } catch (error) {
    console.error('保存用户档案失败:', error);
    ElMessage.error('保存失败，请稍后重试');
  } finally {
    loading.value = false;
  }
};

// 重新测试
const resetSurvey = () => {
  questions.value.forEach(q => {
    form.answers[q.id] = '';
  });
  resultData.value = null;
  showResult.value = false;
};

// 页面加载时获取问卷题目和用户电子档案
onMounted(() => {
  fetchQuestions();
  fetchUserProfile();
  loadSchools();
});
</script>

<style scoped>
.volunteer-planning {
  min-height: 100vh;
  margin-top: 70px;
  background: linear-gradient(180deg, #f0fdf4 0%, #dcfce7 100%);
  padding: 10px;
}

.page-header {
  text-align: center;
  padding: 10px 0;
}

.title {
  font-size: 22px;
  color: #15803d;
  font-weight: 600;
}

/* 调查问卷部分 */
.survey-section {
  max-width: 100%;
  margin: 0 auto;
}

.survey-card {
  background: white;
  border-radius: 10px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  padding: 15px;
  border: 1px solid #e2e8f0;
}

.survey-title {
  font-size: 17px;
  color: #15803d;
  text-align: center;
  margin-bottom: 15px;
  padding-bottom: 8px;
  border-bottom: 2px solid #22c55e;
}

.basic-info {
  background: #f0fdf4;
  border-radius: 6px;
  padding: 12px;
  margin-bottom: 15px;
  border: 1px solid #dcfce7;
}

.info-row {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  margin-bottom: 10px;
}

.info-row:last-child {
  margin-bottom: 0;
}

.info-item {
  display: flex;
  align-items: center;
  gap: 8px;
}

.info-item label {
  font-weight: 500;
  color: #475569;
  min-width: 65px;
  font-size: 13px;
}

.info-input {
  width: 180px;
}

.questions-list {
  margin-bottom: 15px;
  position: relative;
}

.questions-list.disabled {
  pointer-events: none;
  opacity: 0.6;
}

.disabled-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(255, 255, 255, 0.9);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10;
  border-radius: 8px;
}

.disabled-content {
  text-align: center;
  padding: 30px;
}

.warning-icon {
  font-size: 48px;
  color: #f59e0b;
  margin-bottom: 15px;
}

.disabled-title {
  font-size: 20px;
  font-weight: 600;
  color: #dc2626;
  margin-bottom: 8px;
}

.disabled-desc {
  font-size: 14px;
  color: #64748b;
}

.question-item {
  margin-bottom: 12px;
  padding: 12px;
  background: #f8fafc;
  border-radius: 6px;
  border-left: 3px solid #22c55e;
}

.question-header {
  display: flex;
  align-items: flex-start;
  margin-bottom: 10px;
}

.question-number {
  font-weight: 600;
  color: #22c55e;
  margin-right: 6px;
  flex-shrink: 0;
}

.question-text {
  font-size: 14px;
  color: #334155;
  line-height: 1.5;
}

.options-list {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}

.option-item {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 8px 12px;
  background: white;
  border: 1px solid #e2e8f0;
  border-radius: 5px;
  cursor: pointer;
  transition: all 0.25s ease;
  min-width: 180px;
  position: relative;
}

.option-item:hover {
  border-color: #22c55e;
  background: #f0fdf4;
}

.option-item.selected {
  border-color: #22c55e;
  background: #dcfce7;
}

.option-item input {
  display: none;
}

.option-label {
  font-weight: 600;
  color: #22c55e;
  min-width: 18px;
}

.option-text {
  color: #475569;
  font-size: 13px;
}

.selected-icon {
  color: #22c55e;
  margin-left: auto;
  font-size: 14px;
}

.submit-section {
  text-align: center;
}

.submit-btn {
  background: linear-gradient(135deg, #22c55e 0%, #16a34a 100%);
  border: none;
  padding: 10px 30px;
  font-size: 14px;
  border-radius: 20px;
  color: white;
}

.submit-btn:hover {
  background: linear-gradient(135deg, #22c55e 0%, #15803d 100%);
}

/* 结果展示部分 */
.result-section {
  max-width: 100%;
  margin: 0 auto;
}

.result-card {
  background: white;
  border-radius: 10px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  padding: 15px;
  border: 1px solid #e2e8f0;
}

.result-header {
  text-align: center;
  margin-bottom: 15px;
}

.result-title {
  font-size: 19px;
  color: #15803d;
  font-weight: 600;
}

.user-info-card {
  background: linear-gradient(135deg, #ffffff 0%, #f0fdf4 100%);
  border-radius: 12px;
  padding: 20px;
  margin-bottom: 20px;
  border: 1px solid #bbf7d0;
  box-shadow: 0 4px 12px rgba(34, 197, 94, 0.08);
}

.info-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  padding-bottom: 15px;
  border-bottom: 2px solid #22c55e;
}

.card-title {
  font-size: 16px;
  font-weight: 600;
  color: #15803d;
  display: flex;
  align-items: center;
  gap: 8px;
}

.card-title::before {
  content: '';
  display: inline-block;
  width: 4px;
  height: 16px;
  background: linear-gradient(180deg, #22c55e 0%, #16a34a 100%);
  border-radius: 2px;
}

.action-buttons {
  display: flex;
  gap: 10px;
}

.edit-btn, .save-btn, .cancel-btn {
  padding: 6px 16px;
  font-size: 13px;
  border-radius: 6px;
  font-weight: 500;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  gap: 4px;
}

.edit-btn {
  background: linear-gradient(135deg, #22c55e 0%, #16a34a 100%);
  border: none;
  color: white;
  box-shadow: 0 2px 8px rgba(34, 197, 94, 0.3);
}

.edit-btn:hover {
  background: linear-gradient(135deg, #16a34a 0%, #15803d 100%);
  box-shadow: 0 4px 12px rgba(34, 197, 94, 0.4);
  transform: translateY(-1px);
}

.save-btn {
  background: linear-gradient(135deg, #10b981 0%, #059669 100%);
  border: none;
  color: white;
  box-shadow: 0 2px 8px rgba(16, 185, 129, 0.3);
}

.save-btn:hover {
  background: linear-gradient(135deg, #059669 0%, #047857 100%);
  box-shadow: 0 4px 12px rgba(16, 185, 129, 0.4);
  transform: translateY(-1px);
}

.cancel-btn {
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  color: #64748b;
}

.cancel-btn:hover {
  background: #f1f5f9;
  border-color: #cbd5e1;
}

.info-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  gap: 16px;
}

.info-box {
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding: 12px 14px;
  background: white;
  border-radius: 8px;
  border: 1px solid #f1f5f9;
  transition: all 0.2s ease;
}

.info-box:hover {
  border-color: #bbf7d0;
  box-shadow: 0 2px 8px rgba(34, 197, 94, 0.1);
}

.info-label {
  font-weight: 500;
  color: #64748b;
  font-size: 12px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.info-value {
  color: #1e293b;
  font-weight: 600;
  font-size: 14px;
  word-break: break-all;
}

.info-value.highlight {
  color: #16a34a;
  font-size: 16px;
  font-weight: 700;
}

.info-input {
  padding: 8px 12px;
  border: 1px solid #e2e8f0;
  border-radius: 6px;
  font-size: 14px;
  color: #334155;
  background: white;
  width: 100%;
  max-width: 200px;
  box-sizing: border-box;
  transition: all 0.2s ease;
}

.info-input:focus {
  outline: none;
  border-color: #22c55e;
  box-shadow: 0 0 0 3px rgba(34, 197, 94, 0.1);
}

.info-select {
  padding: 8px 12px;
  border: 1px solid #e2e8f0;
  border-radius: 6px;
  font-size: 14px;
  color: #334155;
  background: white;
  width: 100%;
  max-width: 200px;
  box-sizing: border-box;
  cursor: pointer;
  transition: all 0.2s ease;
}

.info-select:focus {
  outline: none;
  border-color: #22c55e;
  box-shadow: 0 0 0 2px rgba(34, 197, 94, 0.2);
}

.loading-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 200px;
}

.waiting-container {
  background: linear-gradient(135deg, #f0f9ff 0%, #e0f2fe 100%);
  border-radius: 8px;
  padding: 24px;
  margin: 16px 0;
  text-align: center;
  box-shadow: 0 2px 8px rgba(59, 130, 246, 0.1);
}

.waiting-animation {
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  color: #3b82f6;
  font-weight: 500;
}

.waiting-text {
  margin-right: 4px;
}

.waiting-dots {
  display: inline-flex;
  align-items: center;
}

.waiting-dots .dot {
  animation: dotPulse 1.4s infinite ease-in-out;
  font-size: 20px;
}

.waiting-dots .dot:nth-child(1) {
  animation-delay: 0s;
}

.waiting-dots .dot:nth-child(2) {
  animation-delay: 0.2s;
}

.waiting-dots .dot:nth-child(3) {
  animation-delay: 0.4s;
}

@keyframes dotPulse {
  0%, 80%, 100% {
    opacity: 0.3;
    transform: scale(0.8);
  }
  40% {
    opacity: 1;
    transform: scale(1.2);
  }
}

.intro-section {
  background: #f8fafc;
  border-radius: 6px;
  padding: 12px;
  margin-bottom: 15px;
}

.advice-section {
  background: #f8fafc;
  border-radius: 6px;
  padding: 15px;
  margin-bottom: 15px;
  line-height: 1.6;
  color: #475569;
}

.advice-section :deep(h3) {
  font-size: 16px;
  color: #15803d;
  font-weight: 600;
  margin-bottom: 12px;
  padding-bottom: 6px;
  border-bottom: 2px solid #22c55e;
}

.advice-section :deep(h4) {
  font-size: 14px;
  color: #16a34a;
  font-weight: 500;
  margin-bottom: 10px;
}

.advice-section :deep(p) {
  text-indent: 2em;
  margin-bottom: 10px;
  font-size: 13px;
}

.intro-text {
  line-height: 1.6;
  color: #475569;
  text-indent: 2em;
  font-size: 13px;
}

.section-card {
  background: #f8fafc;
  border-radius: 6px;
  padding: 15px;
  margin-bottom: 15px;
}

.section-title {
  font-size: 16px;
  color: #15803d;
  font-weight: 600;
  margin-bottom: 12px;
  padding-bottom: 6px;
  border-bottom: 2px solid #22c55e;
}

.subsection {
  margin-bottom: 15px;
}

.subsection:last-child {
  margin-bottom: 0;
}

.subsection-title {
  font-size: 14px;
  color: #16a34a;
  font-weight: 500;
  margin-bottom: 10px;
}

.content-block {
  margin-bottom: 10px;
}

.content-block:last-child {
  margin-bottom: 0;
}

.content-title {
  font-size: 13px;
  color: #475569;
  font-weight: 500;
  margin-bottom: 6px;
}

.content-text {
  line-height: 1.6;
  color: #64748b;
  font-size: 13px;
  text-indent: 2em;
}

.medical-pass, .political-pass {
  color: #22c55e;
  font-weight: 600;
}

.medical-fail, .political-fail {
  color: #ef4444;
  font-weight: 600;
}

.retest-section {
  text-align: center;
  margin-top: 15px;
}

.retest-btn {
  background: linear-gradient(135deg, #22c55e 0%, #16a34a 100%);
  border: none;
  padding: 10px 35px;
  font-size: 14px;
  border-radius: 20px;
  color: white;
  width: 100%;
  max-width: 260px;
}

.retest-btn:hover {
  background: linear-gradient(135deg, #22c55e 0%, #15803d 100%);
}

@media (max-width: 768px) {
  .volunteer-planning {
    padding: 5px;
  }
  
  .survey-card, .result-card {
    padding: 10px;
  }
  
  .info-row {
    flex-direction: column;
  }
  
  .info-input {
    width: 100%;
  }
  
  .options-list {
    flex-direction: column;
  }
  
  .option-item {
    min-width: 100%;
  }
  
  .info-grid {
    flex-direction: column;
  }
}
</style>